/* ==========================================================================
   Mosmi — storefront interactions
   Hero carousel · header search · menu + bag drawers · toast
   Bag is wired to Shopify's AJAX Cart API (window.routes).
   Config comes from window.mosmiConfig (emitted by sections/mosmi-header.liquid).
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.mosmiConfig || {};
  var routes = window.routes || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---- Money formatting (Shopify-compatible) ---------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var fmt = format || cfg.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(n, dflt) { return (n == null || isNaN(n)) ? dflt : n; }
    function thousands(number, precision, thousandsSep, decimalSep) {
      precision = defaultTo(precision, 2);
      thousandsSep = defaultTo(thousandsSep, ',');
      decimalSep = defaultTo(decimalSep, '.');
      var num = (cents / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      var centsPart = parts[1] ? decimalSep + parts[1] : '';
      return dollars + centsPart;
    }

    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---- Toast ------------------------------------------------------------ */
  var toastEl, toastTimer;
  function flash(msg) {
    toastEl = toastEl || $('[data-mosmi-toast]');
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  }

  /* ---- Overlay / drawer coordination ------------------------------------ */
  var overlay, bagDrawer, menuDrawer, header;
  var lockedScrollY = null;
  // body { overflow: hidden } alone doesn't reliably stop background touch
  // scroll on iOS/Android — pinning body to a fixed position (and restoring
  // scroll on release) is the cross-browser-safe way to lock the page.
  function lockScroll() {
    if (lockedScrollY !== null) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockedScrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    if (lockedScrollY === null) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, lockedScrollY);
    lockedScrollY = null;
  }
  function refreshOverlay() {
    var anyPanel = (bagDrawer && bagDrawer.classList.contains('is-open')) ||
                   (menuDrawer && menuDrawer.classList.contains('is-open'));
    if (overlay) overlay.classList.toggle('is-on', !!anyPanel);
    document.body.classList.toggle('mosmi-panel-open', !!anyPanel);
    if (anyPanel) lockScroll(); else unlockScroll();
  }
  function closeAll() {
    if (bagDrawer) bagDrawer.classList.remove('is-open');
    if (menuDrawer) menuDrawer.classList.remove('is-open');
    if (header) header.classList.remove('is-search-open');
    refreshOverlay();
  }
  function openBag() { closeAll(); if (bagDrawer) bagDrawer.classList.add('is-open'); refreshOverlay(); }
  function openMenu() { closeAll(); if (menuDrawer) menuDrawer.classList.add('is-open'); refreshOverlay(); }

  /* ---- Cart -------------------------------------------------------------- */
  function getCart() {
    return fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }
  function cartAdd(id, quantity) {
    return fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); });
  }
  function cartChange(key, quantity) {
    return fetch(routes.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    var count = cart.item_count;
    // Badge
    $all('[data-mosmi-bag-count]').forEach(function (el) { el.textContent = count; });
    $all('[data-mosmi-badge]').forEach(function (b) { b.style.opacity = count > 0 ? '1' : '0'; });

    // Items
    var body = $('[data-mosmi-bag-items]');
    var empty = $('[data-mosmi-bag-empty]');
    if (empty) empty.style.display = count > 0 ? 'none' : 'block';
    if (body) {
      body.innerHTML = cart.items.map(function (i) {
        var meta = i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : (i.product_type || '');
        var img = i.featured_image && i.featured_image.url
          ? '<img class="m-bag__thumb" src="' + i.featured_image.url + '" alt="' + (i.featured_image.alt || '') + '" width="64" height="82" loading="lazy">'
          : '<div class="m-bag__thumb"></div>';
        return '<div class="m-bag__item" data-key="' + i.key + '">' +
          img +
          '<div class="m-bag__mid">' +
            '<p class="m-bag__iname">' + i.product_title + '</p>' +
            '<p class="m-bag__imeta">' + (meta ? meta + ' &middot; ' : '') + 'Qty ' + i.quantity + '</p>' +
          '</div>' +
          '<div class="m-bag__right">' +
            '<p class="m-bag__iprice">' + formatMoney(i.final_line_price) + '</p>' +
            '<button type="button" class="m-bag__remove" data-mosmi-remove="' + i.key + '">Remove</button>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    // Totals
    var subtotal = cart.total_price;
    var subtotalEl = $('[data-mosmi-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    $all('[data-mosmi-checkout-total]').forEach(function (el) { el.textContent = formatMoney(subtotal); });

    var pct = parseFloat(cfg.prepaidPercent || 0);
    var saving = Math.round(subtotal * pct / 100);
    var savingEl = $('[data-mosmi-prepaid-saving]');
    if (savingEl) savingEl.textContent = '− ' + formatMoney(saving);
    var savingRow = $('[data-mosmi-prepaid-row]');
    if (savingRow) savingRow.style.display = (pct > 0 && subtotal > 0) ? 'flex' : 'none';

    var threshold = parseInt(cfg.freeDeliveryThreshold || 0, 10);
    var note = $('[data-mosmi-ship-note]');
    if (note) {
      if (threshold > 0 && subtotal >= threshold) note.textContent = 'Free delivery unlocked · 2–4 days';
      else if (subtotal > 0 && threshold > 0) note.textContent = 'Add ' + formatMoney(threshold - subtotal) + ' for free delivery';
      else if (threshold > 0) note.textContent = 'Free delivery over ' + formatMoney(threshold) + ' · Cash on Delivery';
      else note.textContent = 'Cash on Delivery available';
    }
  }

  /* ---- Added-to-bag popup (phones + portrait tablets) -------------------
     Khaadi-style confirmation after an add: the piece, then Continue
     Shopping or Checkout. Desktop keeps the toast. Built on first use. */
  var phoneMq = window.matchMedia('(max-width: 680px), (max-width: 1023px) and (orientation: portrait)');
  var addedEl, addedLastFocus;
  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }
  function closeAdded() {
    if (!addedEl || !addedEl.classList.contains('is-on')) return;
    addedEl.classList.remove('is-on');
    addedEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mosmi-added-open');
    if (addedLastFocus && addedLastFocus.focus) addedLastFocus.focus();
  }
  function showAdded(item, name) {
    if (!addedEl) {
      addedEl = document.createElement('div');
      addedEl.className = 'mosmi m-added';
      addedEl.setAttribute('aria-hidden', 'true');
      addedEl.innerHTML =
        '<div class="m-added__backdrop" data-added-close></div>' +
        '<div class="m-added__card" role="dialog" aria-modal="true" aria-labelledby="m-added-title">' +
          '<button class="m-added__x" type="button" data-added-close aria-label="Close">' +
            '<svg width="13" height="13" viewBox="0 0 15 15" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M1 1l13 13M14 1L1 14"/></svg>' +
          '</button>' +
          '<div class="m-added__media"></div>' +
          '<div class="m-added__body">' +
            '<p class="m-added__title" id="m-added-title">Added to Bag</p>' +
            '<p class="m-added__text"></p>' +
            '<button class="m-added__btn m-added__btn--ghost" type="button" data-added-close>Continue Shopping</button>' +
            '<a class="m-added__btn" href="' + ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout">Checkout</a>' +
          '</div>' +
        '</div>';
      document.body.appendChild(addedEl);
      addedEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-added-close]')) { e.preventDefault(); closeAdded(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAdded(); });
    }
    var media = $('.m-added__media', addedEl);
    var img = item && (item.image || (item.featured_image && item.featured_image.url));
    media.innerHTML = img ? '<img src="' + sizedImage(img, 360) + '" alt="" width="180" height="240">' : '';
    var title = (item && item.product_title) || name || 'Item';
    var variant = item && item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '';
    var text = $('.m-added__text', addedEl);
    text.textContent = '';
    var strong = document.createElement('strong');
    strong.textContent = title + variant;
    text.appendChild(strong);
    text.appendChild(document.createTextNode(' was successfully added to your shopping bag.'));
    addedLastFocus = document.activeElement;
    addedEl.setAttribute('aria-hidden', 'false');
    addedEl.classList.add('is-on');
    document.body.classList.add('mosmi-added-open');
    var checkout = $('a.m-added__btn', addedEl);
    if (checkout) setTimeout(function () { checkout.focus({ preventScroll: true }); }, 60);
  }

  // Resolves true once the item is in the bag, false if it couldn't be added.
  function addToCart(id, quantity, name) {
    return cartAdd(id, quantity).then(function (res) {
      if (!res.ok) {
        flash((res.body && res.body.description) || 'Could not add to bag');
        return false;
      }
      var item = res.body && res.body.items && res.body.items[0];
      return getCart().then(function (cart) {
        renderCart(cart);
        if (phoneMq.matches) showAdded(item, name);
        else flash((name || 'Item') + ' added to bag');
        return true;
      });
    }).catch(function () { flash('Something went wrong'); return false; });
  }

  function buyNow(id) {
    return cartAdd(id, 1).then(function (res) {
      if (!res.ok) {
        flash((res.body && res.body.description) || 'Could not add to bag');
        return;
      }
      window.location.href = '/checkout';
    }).catch(function () { flash('Something went wrong'); });
  }

  /* ---- Hero carousel ---------------------------------------------------- */
  function initHero(root) {
    var slides = $all('[data-mosmi-slide]', root);
    var panels = $all('[data-mosmi-panel]', root);
    var dots = $all('[data-mosmi-dot]', root);
    if (!slides.length) return;
    var idx = 0, total = slides.length, timer;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var interval = (parseFloat(root.getAttribute('data-interval')) || 6.5) * 1000;

    function go(n) {
      idx = (n + total) % total;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
        /* Slide images can be links. Only the visible one belongs in the tab
           order, otherwise keyboard users land on links they cannot see. */
        var link = s.querySelector('.m-hero__link');
        if (link) link.setAttribute('tabindex', i === idx ? '0' : '-1');
      });
      panels.forEach(function (p, i) { p.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function start() { if (autoplay && total > 1) { stop(); timer = setInterval(function () { go(idx + 1); }, interval); } }
    function stop() { clearInterval(timer); }

    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); start(); }); });
    var next = $('[data-mosmi-next]', root);
    if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
    go(0); start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
  }

  /* ---- Transparent header over the hero ---------------------------------
     The header only goes transparent when a hero sits directly beneath it.
     It returns to solid on hover, while the search is open, and once the
     page has scrolled far enough that the hero is no longer behind it. */
  function initTransparentHeader() {
    if (cfg.headerTransparent === false) return;
    if (!header) return;

    var section = header.closest('.mosmi-header-section') || header.parentNode;
    var hero = $('[data-mosmi-hero]');
    if (!hero || !section) return;

    // Only overlay when the hero is the first thing in the page body, i.e. it
    // starts within a header's height of the top of the main content.
    var main = hero.closest('main') || document.body;
    var firstSection = main.querySelector('.shopify-section');
    if (firstSection && !firstSection.contains(hero)) return;

    section.classList.add('is-overlay');

    var hovering = false;
    function apply() {
      var stage = $('.m-hero__stage', hero);
      var limit = (stage ? stage.offsetHeight : hero.offsetHeight) - header.offsetHeight * 2;
      var clear = !hovering
        && !header.classList.contains('is-search-open')
        && window.pageYOffset < Math.max(limit, 0);
      header.classList.toggle('is-transparent', clear);
    }

    header.addEventListener('mouseenter', function () { hovering = true; apply(); });
    header.addEventListener('mouseleave', function () { hovering = false; apply(); });
    header.addEventListener('focusin', function () { hovering = true; apply(); });
    header.addEventListener('focusout', function () { hovering = false; apply(); });

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { apply(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', apply);

    // Deferred to a frame: classList.add('is-overlay') above is a style
    // write, and apply() immediately reads offsetHeight — calling it
    // synchronously here forces the browser to flush layout early instead
    // of batching it with the page's first natural paint.
    window.requestAnimationFrame(apply);
    return apply;
  }

  /* ---- Wire up on load -------------------------------------------------- */
  function init() {
    overlay = $('[data-mosmi-overlay]');
    bagDrawer = $('[data-mosmi-bag]');
    menuDrawer = $('[data-mosmi-menu]');
    header = $('[data-mosmi-header]');

    var syncHeader = initTransparentHeader();

    // Header controls
    var searchBtn = $('[data-mosmi-search-toggle]');
    if (searchBtn && header) searchBtn.addEventListener('click', function () {
      var open = header.classList.toggle('is-search-open');
      if (syncHeader) syncHeader();
      if (open) { var inp = $('.m-search__input', header); if (inp) setTimeout(function () { inp.focus(); }, 120); }
    });
    $all('[data-mosmi-open-bag]').forEach(function (b) { b.addEventListener('click', openBag); });
    $all('[data-mosmi-open-menu]').forEach(function (b) { b.addEventListener('click', openMenu); });
    $all('[data-mosmi-close]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); closeAll(); }); });
    if (overlay) overlay.addEventListener('click', closeAll);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    // Menu links close the drawer
    $all('[data-mosmi-menu] a[href^="#"], [data-mosmi-menu] a[href]').forEach(function (a) {
      a.addEventListener('click', function () { setTimeout(closeAll, 60); });
    });

    // Product cards: buy now + add to bag (event delegation)
    document.addEventListener('click', function (e) {
      var buy = e.target.closest('[data-mosmi-buynow]');
      if (buy) {
        e.preventDefault();
        var buyId = buy.getAttribute('data-mosmi-buynow');
        if (buyId) buyNow(buyId);
        return;
      }
      var add = e.target.closest('[data-mosmi-add]');
      if (add) {
        e.preventDefault();
        var id = add.getAttribute('data-mosmi-add');
        var name = add.getAttribute('data-mosmi-name') || 'Item';
        if (id) addToCart(id, 1, name);
        return;
      }
    });

    // Bag remove (delegated)
    if (bagDrawer) bagDrawer.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-mosmi-remove]');
      if (rm) {
        e.preventDefault();
        cartChange(rm.getAttribute('data-mosmi-remove'), 0).then(renderCart);
      }
    });

    // Checkout
    $all('[data-mosmi-checkout]').forEach(function (b) {
      b.addEventListener('click', function () { window.location.href = '/checkout'; });
    });

    // Hero
    $all('[data-mosmi-hero]').forEach(initHero);

    // Initial cart paint
    getCart().then(renderCart).catch(function () {});

    // Public API for other sections (product page, etc.)
    window.Mosmi = {
      addToCart: addToCart,
      openBag: openBag,
      getCart: function () { return getCart().then(function (c) { renderCart(c); return c; }); },
      flash: flash,
      lockScroll: lockScroll,
      unlockScroll: unlockScroll
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
